<div class="header list-header d-none d-md-block">
  <h1 class="d-inline-block v-align-middle">{{ title | translate }}</h1>
  <astral-button class="btn-list-header" variant="secondary" type="button" icon="plus" labelKey="CREATE_BTN" (click)="onCreateItem()"></astral-button>
  @if (excelReady) {
    <app-excel-list
      class="btn-list-header"
      [columnDefinition]="excelColumnDefinition"
      [selectedListViewColumns]="selectedColumns"
      [excelContext]="excelContext"
      [filter]="filterState"
      [fileName]="excelFileName"
      [selectedIds]="selectedArticleIds"
      [affectedItemsCount]="selectedArticleCount"
      [allSelected]="allArticlesSelected"
      [totalResults]="totalArticles"
    ></app-excel-list>
  }
</div>
<div class="header list-header d-flex d-md-none align-items-center">
  <h1 class="w-100">{{ title | translate }}</h1>
  <astral-button class="btn-list-header" variant="secondary" type="button" icon="plus" labelKey="CREATE_BTN" (click)="onCreateItem()"></astral-button>
  @if (excelReady) {
    <app-excel-list
      [columnDefinition]="excelColumnDefinition"
      [selectedListViewColumns]="selectedColumns"
      [excelContext]="excelContext"
      [filter]="filterState"
      [fileName]="excelFileName"
      [selectedIds]="selectedArticleIds"
      [affectedItemsCount]="selectedArticleCount"
      [allSelected]="allArticlesSelected"
      [totalResults]="totalArticles"
      [isMobile]="true"
    ></app-excel-list>
  }
</div>

<app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>

<app-multiselect-list-view
  [columnDefinition]="columnDefinition"
  [itemsSource]="itemsSource"
  [contextMenuDefinition]="contextMenuDefinition"
  [menuDefinition]="menuDefinition"
    [preferencesKey]="preferencesKey"
    [rememberPagination]="true"
  (onColumnChange)="onColumnChange($event)"
  (selectedItemsChange)="onSelectedArticlesChange($event)"
  (rowClick)="onRowClicked($event)"
  [isToolbarSticky]="true"
>
</app-multiselect-list-view>
